export interface SeoHelmet {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle: string;
  ogDescription: string;
  ogType: string;
  ogUrl: string;
}

export function getHomePageSeo(): SeoHelmet {
  return {
    title: '调教——专业技能塑造与行为训练完全指南 | 调教方法·行为调教技巧·技能调教训练',
    description: '「调教」是专业技能塑造与行为训练完全指南，深入解析调教的核心理念、科学方法论与实战技巧。涵盖宠物调教、自我调教提升、行为调教技巧与技能调教训练，帮助训练师、教育者及自我提升者掌握高效调教策略。',
    keywords: '调教,调教方法,行为调教技巧,技能调教训练,宠物调教,自我调教提升,调教策略指南',
    canonicalUrl: 'https://trainology.github.io',
    ogTitle: '调教——专业技能塑造与行为训练完全指南',
    ogDescription: '深入解析调教的核心理念、科学方法论与实战技巧，帮助训练师、教育者及自我提升者掌握高效调教策略。',
    ogType: 'website',
    ogUrl: 'https://trainology.github.io',
  };
}

export function getCategoryPageSeo(slug: string, name: string, description: string): SeoHelmet {
  return {
    title: `${name}——调教分类 | 调教指南`,
    description: `${description}。浏览${name}相关的专业文章、训练方法和实战技巧，获取最权威的${name}内容。`,
    keywords: `${name},调教,行为训练,技能塑造,${name}方法`,
    canonicalUrl: `https://trainology.github.io/category/${slug}`,
    ogTitle: `${name}——调教指南`,
    ogDescription: description,
    ogType: 'website',
    ogUrl: `https://trainology.github.io/category/${slug}`,
  };
}

export function getArticlePageSeo(title: string, slug: string, excerpt: string, tags: string[]): SeoHelmet {
  return {
    title: `${title} | 调教指南`,
    description: excerpt.substring(0, 150),
    keywords: tags.join(','),
    canonicalUrl: `https://trainology.github.io/article/${slug}`,
    ogTitle: title,
    ogDescription: excerpt.substring(0, 150),
    ogType: 'article',
    ogUrl: `https://trainology.github.io/article/${slug}`,
  };
}

export function getAboutPageSeo(): SeoHelmet {
  return {
    title: '关于我们——调教指南 | 品牌介绍·专业团队·联系方式',
    description: '「调教指南」是国内领先的行为科学与技能训练知识平台。了解我们的品牌故事、专业团队、核心理念和联系方式，获取最专业的行为调教知识与服务。',
    keywords: '调教指南,关于我们,品牌介绍,调教团队,联系方式,行为科学',
    canonicalUrl: 'https://trainology.github.io/about',
    ogTitle: '关于我们——调教指南',
    ogDescription: '了解调教指南的品牌故事、专业团队和核心理念。',
    ogType: 'website',
    ogUrl: 'https://trainology.github.io/about',
  };
}

export function applySeo(seo: SeoHelmet): void {
  document.title = seo.title;
  const setMeta = (name: string, content: string, attr: string = 'name') => {
    let el = document.querySelector(`meta[${attr}="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.setAttribute(attr, name);
      document.head.appendChild(el);
    }
    el.setAttribute('content', content);
  };
  setMeta('description', seo.description);
  setMeta('keywords', seo.keywords);
  const canonicalEl = document.querySelector('link[rel="canonical"]');
  if (canonicalEl) canonicalEl.setAttribute('href', seo.canonicalUrl);
  setMeta('og:title', seo.ogTitle, 'property');
  setMeta('og:description', seo.ogDescription, 'property');
  setMeta('og:type', seo.ogType, 'property');
  setMeta('og:url', seo.ogUrl, 'property');
  setMeta('twitter:card', 'summary_large_image', 'name');
  setMeta('twitter:title', seo.ogTitle, 'name');
  setMeta('twitter:description', seo.ogDescription, 'name');
}

export function getOrganizationSchema(): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '调教指南',
    url: 'https://trainology.github.io',
    description: '专业技能塑造与行为训练完全指南',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      telephone: '400-888-9999',
      email: 'contact@tiaojiao-guide.com',
      availableLanguage: ['Chinese'],
    },
  };
}

export function getBreadcrumbSchema(items: { name: string; url: string }[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function getArticleSchema(article: {
  title: string;
  description: string;
  author: string;
  datePublished: string;
  url: string;
  imageUrl?: string;
}): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.description,
    author: {
      '@type': 'Person',
      name: article.author,
    },
    datePublished: article.datePublished,
    dateModified: article.datePublished,
    url: article.url,
    ...(article.imageUrl ? { image: article.imageUrl } : {}),
    publisher: {
      '@type': 'Organization',
      name: '调教指南',
    },
  };
}

export function getFaqSchema(faqs: { question: string; answer: string }[]): Record<string, unknown> {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}